/**
 * Community Entity Normalization Utilities
 *
 * Splits CommunityPost (with embedded author) into NormalizedPost (authorId ref)
 * + CommunityUser. Reverse operation denormalizes back for UI consumption.
 */

import type { CommunityPost, CommunityUser } from "./types"
import type { NormalizedPost, NormalizedPostResult, NormalizedPostListResult } from "./types"

/** 将完整 CommunityPost 拆为 NormalizedPost + CommunityUser */
export function normalizePost(post: CommunityPost): NormalizedPostResult {
  const { author, ...rest } = post
  return {
    post: { ...rest, authorId: author.id },
    author,
  }
}

/** 将 NormalizedPost + CommunityUser 拼回 CommunityPost */
export function denormalizePost(post: NormalizedPost, author: CommunityUser): CommunityPost {
  const { authorId: _, ...rest } = post
  return { ...rest, author }
}

/** 批量归一化（只返回实体，分页信息由调用方从原始 API 响应获取） */
export function normalizePostList(posts: CommunityPost[]): NormalizedPostListResult {
  const authorMap = new Map<string, CommunityUser>()
  const normalized = posts.map((p) => {
    const { post, author } = normalizePost(p)
    authorMap.set(author.id, author)
    return post
  })
  return {
    posts: normalized,
    authors: Array.from(authorMap.values()),
  }
}
